import { Patients } from "./patients";

export class Personne {
  id: number;
  nom: string;
  prenom: string;
  sexe: string;
  portable: string;
  fixe: string;
  parente: string;
  typeContact: string;
  ordre: number;
  adresse: string;
  patient?: Patients;

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/personne.ts